<template>
    <div class="log-button-vue" @click="handleClick">
        <img src="/media/images/log_file_hover.svg" />
    </div>
</template>

<script>
export default {
    name: "LogButton",
    props: {
        route: String,
        onClick: Function,
    },
    methods: {
        handleClick(event) {
            if (this.route) {
                this.$router.push(this.route);
            } else if (this.onClick) {
                this.onClick(event);
            }
        },
    },
};
</script>

<style scoped>
.log-button-vue {
    background-color: #41abc4;
    width: 34px;
    height: 34px;
    border-radius: 4px;
    padding: 4px;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}

.log-button-vue:hover {
    cursor: pointer;
}

.log-button-vue > img {
    width: 35px;
    height: 35px;
    position: relative;
    display: block;
}
</style>